import api from '@/api'

export default {
  all() {
    return api.get('/inbound-orders')
  },

  approve(order) {
    return api.post(`/inbound-orders/${order.id}/approve`)
  },

  accept(order) {
    return api.post(`/inbound-orders/${order.id}/accept`)
  },

  receive(order) {
    return api.post(`/inbound-orders/${order.id}/receive`, { items: order.items })
  },

  putAway(order, cartons = false) {
    if(!cartons) {
      return api.post(`/inbound-orders/${order.id}/put-away`, { pallets: order.pallets })
    } else {
      return api.post(`/inbound-orders/${order.id}/put-away-cartons`, { cartons: order.cartons })
    }
  }
}
